/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { ExternalDocumentation } from '../../../core/models/common/ExternalDocumentation';
import { INamed } from '../../../core/models/common/INamed';
import { IVisitor } from '../../../core/visitors/IVisitor';
import { IOasPropertySchema } from '../../models/IOasPropertySchema';
import { OasSchema } from '../../models/OasSchema';
import { OasXML } from '../../models/OasXML';
import { IOasVisitor } from '../../visitors/IOasVisitor';

/**
 * @author eric.wittmann@gmail.com
 * @class
 * @extends OasSchema
 */
export class Oas20Schema extends OasSchema {
    public discriminator : string;

    /**
     * @see io.apicurio.datamodels.openapi.models.OasSchema#createExternalDocumentation()
     * @return {ExternalDocumentation}
     */
    public createExternalDocumentation() : ExternalDocumentation {
        let rval : Oas20ExternalDocumentation = new Oas20ExternalDocumentation();
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    /**
     * @see io.apicurio.datamodels.openapi.models.OasSchema#createXML()
     * @return {OasXML}
     */
    public createXML() : OasXML {
        let rval : Oas20XML = new Oas20XML();
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    /**
     * @see io.apicurio.datamodels.openapi.models.OasSchema#createAllOfSchema()
     * @return {OasSchema}
     */
    public createAllOfSchema() : OasSchema {
        let rval : Oas20Schema.Oas20AllOfSchema = new Oas20Schema.Oas20AllOfSchema();
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    /**
     * @see io.apicurio.datamodels.openapi.models.OasSchema#createItemsSchema()
     * @return {OasSchema}
     */
    public createItemsSchema() : OasSchema {
        let rval : Oas20Schema.Oas20ItemsSchema = new Oas20Schema.Oas20ItemsSchema();
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    /**
     * @see io.apicurio.datamodels.openapi.models.OasSchema#createAdditionalPropertiesSchema()
     * @return {OasSchema}
     */
    public createAdditionalPropertiesSchema() : OasSchema {
        let rval : Oas20Schema.Oas20AdditionalPropertiesSchema = new Oas20Schema.Oas20AdditionalPropertiesSchema();
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    /**
     * @see io.apicurio.datamodels.openapi.models.OasSchema#createPropertySchema(java.lang.String)
     * @param {string} propertyName
     * @return {OasSchema}
     */
    public createPropertySchema(propertyName : string) : OasSchema {
        let rval : Oas20Schema.Oas20PropertySchema = new Oas20Schema.Oas20PropertySchema(propertyName);
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    constructor() {
        super();
        if(this.discriminator===undefined) this.discriminator = null;
    }
}
Oas20Schema["__class"] = "io.apicurio.datamodels.openapi.v2.models.Oas20Schema";
Oas20Schema["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.core.models.common.IExternalDocumentationParent"];



export namespace Oas20Schema {

    export class Oas20AdditionalPropertiesSchema extends Oas20Schema {
        /**
         * @see io.apicurio.datamodels.core.models.common.Schema#accept(io.apicurio.datamodels.core.visitors.IVisitor)
         * @param {*} visitor
         */
        public accept(visitor : IVisitor) {
            let viz : IOasVisitor = <IOasVisitor><any>visitor;
            viz.visitAdditionalPropertiesSchema(this);
        }

        constructor() {
            super();
        }
    }
    Oas20AdditionalPropertiesSchema["__class"] = "io.apicurio.datamodels.openapi.v2.models.Oas20Schema.Oas20AdditionalPropertiesSchema";
    Oas20AdditionalPropertiesSchema["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.core.models.common.IExternalDocumentationParent"];



    export class Oas20ItemsSchema extends Oas20Schema {
        /**
         * @see io.apicurio.datamodels.core.models.common.Schema#accept(io.apicurio.datamodels.core.visitors.IVisitor)
         * @param {*} visitor
         */
        public accept(visitor : IVisitor) {
            let viz : IOasVisitor = <IOasVisitor><any>visitor;
            viz.visitItemsSchema(this);
        }

        constructor() {
            super();
        }
    }
    Oas20ItemsSchema["__class"] = "io.apicurio.datamodels.openapi.v2.models.Oas20Schema.Oas20ItemsSchema";
    Oas20ItemsSchema["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.core.models.common.IExternalDocumentationParent"];



    export class Oas20AllOfSchema extends Oas20Schema {
        /**
         * @see io.apicurio.datamodels.core.models.common.Schema#accept(io.apicurio.datamodels.core.visitors.IVisitor)
         * @param {*} visitor
         */
        public accept(visitor : IVisitor) {
            let viz : IOasVisitor = <IOasVisitor><any>visitor;
            viz.visitAllOfSchema(this);
        }

        constructor() {
            super();
        }
    }
    Oas20AllOfSchema["__class"] = "io.apicurio.datamodels.openapi.v2.models.Oas20Schema.Oas20AllOfSchema";
    Oas20AllOfSchema["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.core.models.common.IExternalDocumentationParent"];



    /**
     * Constructor.
     * @param {string} propertyName
     * @class
     * @extends Oas20Schema
     */
    export class Oas20PropertySchema extends Oas20Schema implements IOasPropertySchema, INamed {
        _propertyName : string;

        public constructor(propertyName : string) {
            super();
            if(this._propertyName===undefined) this._propertyName = null;
            this._propertyName = propertyName;
        }

        /**
         * @see io.apicurio.datamodels.openapi.models.IOasPropertySchema#getPropertyName()
         * @return {string}
         */
        public getPropertyName() : string {
            return this._propertyName;
        }

        /**
         * 
         * @return {string}
         */
        public getName() : string {
            return this._propertyName;
        }

        /**
         * @see io.apicurio.datamodels.openapi.models.IOasPropertySchema#rename(java.lang.String)
         * @param {string} newName
         */
        public rename(newName : string) {
            this._propertyName = newName;
        }

        /**
         * @see io.apicurio.datamodels.core.models.common.Schema#accept(io.apicurio.datamodels.core.visitors.IVisitor)
         * @param {*} visitor
         */
        public accept(visitor : IVisitor) {
            let viz : IOasVisitor = <IOasVisitor><any>visitor;
            viz.visitPropertySchema(<IOasPropertySchema><any>this);
        }
    }
    Oas20PropertySchema["__class"] = "io.apicurio.datamodels.openapi.v2.models.Oas20Schema.Oas20PropertySchema";
    Oas20PropertySchema["__interfaces"] = ["io.apicurio.datamodels.openapi.models.IOasPropertySchema","io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.core.models.common.INamed","io.apicurio.datamodels.core.models.common.IExternalDocumentationParent"];


}




import { Oas20XML } from './Oas20XML';


import { Oas20ExternalDocumentation } from './Oas20ExternalDocumentation';

